import React from "react";
import {
  Box,
  Dialog,
  Tooltip,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { isValidArray } from "utils/array";
import Button from "components/common/button/Button";
import useModalWrapper from "components/common/modals/modalWrapper/useModalWrapper";

import "./ModalWrapper.css";

const ModalWrapper = ({
  title = "Are you sure?",
  titleStyle = {},
  children,
  headerStyle = {},
  renderFooter = true,
  footerMessage = null,
  actionButtons = [],
  onClose,
  showTitle = true,
  show = false,
  maxWidth = "sm",
  isFullScreen = false,
  showCloseIcon = true,
  TriggerButton,
  TriggerButtonProps = {},
  dialogProps = {},
  showContentDivider = false,
  showTitleDivider = true,
  style,
}) => {
  const { theme, isOpen, handleOpen, handleClose } = useModalWrapper(
    show,
    onClose
  );

  const [leftButtons, rightButtons] = actionButtons.reduce(
    (acc, button) => {
      acc[button?.isLeft ? 0 : 1].push(button);

      return acc;
    },
    [[], []]
  );

  return (
    <>
      {TriggerButton && (
        <TriggerButton onClick={handleOpen} {...TriggerButtonProps} />
      )}
      <Dialog
        open={isOpen}
        fullScreen={isFullScreen}
        maxWidth={maxWidth}
        fullWidth={true}
        onClose={handleClose}
        {...dialogProps}
        sx={{
          ...style,
          overflow: "hidden",
        }}
      >
        {showTitle && (
          <>
            <DialogTitle style={{ ...headerStyle, padding: "16px 24px" }}>
              <Box
                className="dialog-header"
                style={{ backgroundColor: theme.palette.background.paper }}
              >
                <div className="dialog-header__title" style={titleStyle}>
                  {title}
                </div>
                {showCloseIcon && (
                  <Tooltip title="Close" placement="bottom">
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </DialogTitle>
            {!showContentDivider && showTitleDivider && title && <Divider />}
          </>
        )}

        <DialogContent dividers={showContentDivider ? true : false}>
          {children}
        </DialogContent>

        {renderFooter && (
          <DialogActions className="d-flex flex-column align-items-center">
            {footerMessage}
            {actionButtons?.length > 0 && (
              <Box
                className={`d-flex align-items-center ${
                  actionButtons?.some((button) => button.isLeft)
                    ? "justify-between"
                    : "flex-end"
                }`}
                style={{
                  width: "100%",
                  padding: "8px 16px",
                  gap: "10px",
                  backgroundColor: theme.palette.background.paper,
                }}
              >
                {isValidArray(leftButtons) && (
                  <Box
                    className="d-flex align-items-center"
                    style={{ gap: "10px" }}
                  >
                    {leftButtons?.map((buttonProps, index) => (
                      <Tooltip title={buttonProps?.tooltip}>
                        <span>
                          <Button key={`left-${index}`} {...buttonProps} />
                        </span>
                      </Tooltip>
                    ))}
                  </Box>
                )}
                {isValidArray(rightButtons) && (
                  <Box
                    className="d-flex flex-end align-items-center"
                    style={{ gap: "10px" }}
                  >
                    {rightButtons?.map((buttonProps, index) => (
                      <Tooltip title={buttonProps?.tooltip}>
                        <span>
                          <Button key={`right-${index}`} {...buttonProps} />
                        </span>
                      </Tooltip>
                    ))}
                  </Box>
                )}
              </Box>
            )}
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default ModalWrapper;
